import { BuildingDTO } from "./building";
import { UnitDTO } from "./unit";
import { FileLog } from "./file";
import { MeterDto } from "./meter";

export enum HeatingConnectedTo {
    PRIVATE_SYSTEM = 'Eigen systeem',
    CENTRAL_SYSTEM = 'Centraal systeem',
    COMBINED_SYSTEM = 'Combinatie privatief-collectief',
    UNKNOWN = 'Onbekend'
}

export enum ThermostatType {
    THERMOSTAT = 'Analoge thermostaat',
    DIGITAL_THERMOSTAT = 'Digitale thermostaat',
    UNKNOWN = 'Onbekend'
}

export enum DeviceType {
    GENERATOR = "Opwekkingstoestel",
    DISTRIBUTION = "Afgiftetoestel",
    MEASUREMENT = "Meettoestel"
}


export enum GeneratorDeviceSubtype {
    GAS_BOILER_CONDENSING = "Gasketel condenserend",
    GAS_BOILER_NON_CONDENSING = "Gasketel niet-condenserend",
    AIR_PUMP_AIR_AIR = "Warmtepomp lucht-lucht",
    GROUND_WATER_HEAT_PUMP = "Warmtepomp grond-water",
    AIR_WATER_HEAT_PUMP = "Warmtepomp lucht-water",
    HEAT_PUMP_HYBRID = "Warmtepomp hybride",
    FLOW_THROUGH_DEVICDE = "Doorstromer",
    SOLAR_BOILER = "Zonneboiler",
    ELECTRIC_BOILER = "Elektrische boiler",
    FUEL_OIL_TANK = "Stookolietank (gebouw)",
    UNKNOWN = "Onbekend"
}

export enum MeasurementDeviceSubType {
    DIGITAL_THERMOSTAT = "Digitale thermostaat",
    ANALOG_THERMOSTAT = "Analoge thermostaat",
}

export enum DistributionDeviceSubType {
    RADIATORS_LOW_TEMPERATURE = "Radiatoren lage temperatuur",
    RADIATORS_NORMAL_TEMPERATURE = "Radiatoren normale temperatuur",
    INFRARED_PANEL = "Infraroodpaneel",
    ACCUMULATION = "Accumulatie",
    AIR_CONDITIONING = "Airconditioning",
    INFRARED_CONVECTOR = "Infrarood convector",
    FLOOR_HEATING = "Vloerverwarming",
    OPEN_HEARTH = "Open haard",
    PELLET_STOVE = "Pelletkachel",
    UNKNOWN = "Onbekend"
}

export enum DeviceDrives {
    SANITARY_HOT_WATER = "Sanitair warm water",
    HEATING = "Verwarming",
    SANITARY_HOT_WATER_AND_HEATING = "Sanitair warm water en verwarming",
    UNKNOWN = "Onbekend"
}

export type ClimatisationDevice = {
    id?: number;
    deviceType: DeviceType;
    deviceSubType: GeneratorDeviceSubtype | DistributionDeviceSubType | MeasurementDeviceSubType;
    connectedToGeneratorDeviceId: number;
    connectedToGeneratorDevice?: ClimatisationDevice;
    climatisationInfo?: ClimatisationInfo;
    drives: DeviceDrives;
    drivesWhichRooms: string;
    deviceLocation: string;
    remarks: string;
    brand: string;
    model: string;
    pictureFileLogIds: number[];
    pictureFileLogs?: FileLog[];
    maintenanceAttestFileLogIds: number[];
    maintenanceAttestFileLogs?: FileLog[];
    installationDate: number;
    serialNumber: string;
    kWh: number;
    acquisitionOrRepairinvoicesFileLogIds: number[];
    acquisitionOrRepairinvoicesFileLogs?: FileLog[];
    manualFileLogIds: number[];
    manualFileLogs?: FileLog[];
    groupedFileLogs?: FileLog[];
}

export enum ClimatisationSource {
    GAS_KETTLE = 'Gas - Niet-condenserende ketel',
    GAS_KETTLE_CONDENSEREND = 'Gas - Condenserende ketel',
    GAS_KETTLE_HR = 'Gas - Hoogrendementsketel',
    ELECTRICITY_HEATING_PUMP = 'Elektriciteit - Warmtepomp lucht-lucht',
    ELECTRICITY_HEATING_PUMP_WATER_WATER = 'Elektriciteit - Warmtepomp water-water',
    ELECTRICITY_HEATING_PUMP_GROUND_GROUND = 'Elektriciteit - Warmtepomp grond-grond',
    ELECTRICITY_HEATING_PUMP_WATER_AIR = 'Elektriciteit - Warmtepomp water-lucht',
    ELECTRICITY_HEATING_PUMP_AIR_WATER = 'Elektriciteit - Warmtepomp lucht-water',
    ELECTRICITY_CONVECTORS = 'Elektriciteit - Convectoren',
    STOOKOLIE = 'Stookolie',
    NOT_APPLICABLE = 'Niet van toepassing',
    HYBRID = 'Hybride',
    UNKNOWN = 'Onbekend'
}

export type ClimatisationInfo = {
    id?: number;
    building: BuildingDTO;
    unit: UnitDTO;
    connectedTo: HeatingConnectedTo;
    climatisationDevices: ClimatisationDevice[];
    gasMeters: MeterDto[];
    remarks: string;
    source: ClimatisationSource;
}
